import React from 'react';
import { Link } from 'react-router-dom';
import { Button, ButtonToolbar, Content, Icon, Panel } from 'rsuite';
import { modifyAccess } from '../../../../helpers/permission';
import * as PERMISSIONS from '../../../../constants/permissions/reservation';
import PageHeader from '../../../../components/PageHeader';
import AccessControl from '../../../../components/AccessControl';
import AccessDenied from '../../../../components/AccessDenied';
import PageLayout from '../../../../components/reservations/PageLayout';
import { reservationsROItemCreatePath } from '../../../Paths';
import ROItemSearch from '../../../../containers/reservations/ROItemSearch';
import ROItemList from '../../../../containers/reservations/ROItemList';

export default () => (
  <PageLayout>
    <AccessControl
      allowOnlyFor={modifyAccess(PERMISSIONS.RO_ITEM)}
      fallback={<AccessDenied />}
    >
      <PageHeader title="Items">
        <Panel bordered>
          <ButtonToolbar style={{ float: 'right' }}>
            <AccessControl allowOnlyFor={modifyAccess(PERMISSIONS.RO_ITEM)}>
              <Link to={reservationsROItemCreatePath}>
                <Button appearance="primary">
                  <Icon icon="plus-circle" /> Create New
                </Button>
              </Link>
            </AccessControl>
          </ButtonToolbar>
          <ROItemSearch placeholder="Search Name or Description" />
        </Panel>
      </PageHeader>
      <Content>
        <ROItemList />
      </Content>
    </AccessControl>
  </PageLayout>
);
